import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";

const faqs = [
  { q: "Bleiben meine Daten bei der iPhone-Reparatur erhalten?", a: "Ja. Bei G-Repair bleiben alle deine persönlichen Daten zu 100% erhalten – dein iPhone wird ausschließlich repariert, es werden keine Daten gelöscht oder eingesehen." },
  { q: "Was kostet eine iPhone-Reparatur bei G-Repair?", a: "G-Repair kalkuliert faire Festpreise pro iPhone-Modell und Reparaturart (z. B. Display oder Akku) – transparent und ohne versteckte Kosten. Die genauen Preise siehst du vorab in unserer Preisliste." },
  { q: "Wie schnell ist meine Express-Reparatur fertig?", a: "Nach Erhalt deines iPhones reparieren wir in der Regel innerhalb eines Werktags. Inklusive Versand bist du meist nach 1–3 Tagen wieder komplett einsatzbereit." },
  { q: "Wie funktioniert der deutschlandweite Einsendeservice?", a: "Du beauftragst die Reparatur online, sendest dein iPhone gut verpackt an uns ein, wir reparieren es und schicken es versichert zurück – bequem von überall in Deutschland." },
];

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="relative z-10 bg-[#050505] py-24 lg:py-36 border-t border-white/10">
      <div className="max-w-3xl mx-auto px-6 lg:px-10">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#888] mb-4">Häufige Fragen</p>
        <h2 className="font-display text-white text-4xl sm:text-5xl leading-[0.95] mb-12">
          Gut zu wissen.
        </h2>
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`} className="border-white/10">
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-white text-base sm:text-lg font-display hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-content-${i}`} className="text-[#999] text-sm leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
